import cx from 'classnames'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'

const ContinueWithSocial = ({ disabled = false, redirectAfterAuth }) => {
  const onClick = () => {
    sendGtmEvent(
      GtmTriggerName.AUTH_GOOGLE,
      'Click to sign in/sign up with Google'
    )

    const state = Buffer.from(
      redirectAfterAuth ? JSON.stringify({ redirectAfterAuth }) : ''
    ).toString('base64')
    const redirectUri = `${window.location.origin}/oauth`

    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${redirectUri}&response_type=token&scope=email%20profile%20openid&openid.realm&include_granted_scopes=true&client_id=${import.meta.env.VITE_GOOGLE_CLIENT_ID}&ss_domain=${window.location.href}&prompt&fetch_basic_profile=true&gsiwebsdk=2&flowName=GeneralOAuthFlow&state=${state}`
  }

  return (
    <button
      className={cx('Register__social-button', {
        'Register__social-button--disabled': disabled,
      })}
      type="button"
      onClick={onClick}
    >
      <i>
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.6821 9.26595H18.9689V9.22921H11.0002V12.7709H16.0041C15.2741 14.8326 13.3124 16.3125 11.0002 16.3125C8.06633 16.3125 5.68766 13.9339 5.68766 11C5.68766 8.06621 8.06633 5.68754 11.0002 5.68754C12.3544 5.68754 13.5865 6.19843 14.5246 7.03293L17.029 4.52853C15.4476 3.05475 13.3324 2.14587 11.0002 2.14587C6.11045 2.14587 2.146 6.11033 2.146 11C2.146 15.8898 6.11045 19.8542 11.0002 19.8542C15.8899 19.8542 19.8543 15.8898 19.8543 11C19.8543 10.4064 19.7932 9.82686 19.6821 9.26595Z"
            fill="#FFC107"
          />
          <path
            d="M3.1665 6.87887L6.07554 9.01228C6.86268 7.06348 8.76898 5.68754 10.9998 5.68754C12.354 5.68754 13.5861 6.19843 14.5242 7.03293L17.0286 4.52853C15.4472 3.05475 13.332 2.14587 10.9998 2.14587C7.5989 2.14587 4.64958 4.0659 3.1665 6.87887Z"
            fill="#FF3D00"
          />
          <path
            d="M11.0001 19.8542C13.2871 19.8542 15.3652 18.979 16.9364 17.5557L14.196 15.2368C13.307 15.9101 12.2021 16.3126 11.0001 16.3126C8.69713 16.3126 6.74169 14.8441 6.00502 12.7948L3.11768 15.0194C4.58304 17.8868 7.55893 19.8542 11.0001 19.8542Z"
            fill="#4CAF50"
          />
          <path
            d="M19.682 9.26587H18.9688V9.22913H11V12.7708H16.0039C15.6533 13.7611 15.0163 14.6151 14.1946 15.2371C14.195 15.2367 14.1955 15.2367 14.1959 15.2362L16.9363 17.5551C16.7424 17.7313 19.8542 15.427 19.8542 11C19.8542 10.4063 19.7931 9.82678 19.682 9.26587Z"
            fill="#1976D2"
          />
        </svg>
      </i>
      Continue with Google
    </button>
  )
}

export default ContinueWithSocial
